var React = require('react');

function LocationInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.50014 0C3.9071 0 0.17041 3.73669 0.17041 8.32968C0.17041 14.0297 7.6247 22.3977 7.94207 22.7512C8.24018 23.0832 8.76064 23.0826 9.0582 22.7512C9.37558 22.3977 16.8299 14.0297 16.8299 8.32968C16.8298 3.73669 13.0931 0 8.50014 0ZM8.50014 12.5206C6.18927 12.5206 4.30929 10.6406 4.30929 8.32968C4.30929 6.01881 6.18931 4.13883 8.50014 4.13883C10.811 4.13883 12.6909 6.01886 12.6909 8.32973C12.6909 10.6406 10.811 12.5206 8.50014 12.5206Z","fill":"white"}));
}

LocationInline.defaultProps = {"width":"17","height":"23","viewBox":"0 0 17 23","fill":"none"};

module.exports = LocationInline;

LocationInline.default = LocationInline;
